import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import Footer from "./Footer";
import Header from "./Header";
import { blogPosts } from "../data/blogPosts";

export default function BlogPage() {
  const canonicalUrl = "https://fold-web-agency.fr/blog";
  const blogStructuredData = {
    "@context": "https://schema.org",
    "@type": "Blog",
    name: "Blog Fold Web Agency",
    url: canonicalUrl,
    publisher: {
      "@type": "Organization",
      name: "Fold Web Agency",
      url: "https://fold-web-agency.fr/",
    },
    blogPost: blogPosts.map((post) => ({
      "@type": "BlogPosting",
      headline: post.title,
      url: `https://fold-web-agency.fr/blog/${post.slug}`,
      datePublished: post.publishedAt,
    })),
  };

  return (
    <div className="min-h-screen" style={{ background: "var(--bg-page)" }}>
      <Helmet>
        <title>Blog web, WordPress et SEO | Fold Web Agency</title>
        <meta
          name="description"
          content="Conseils pour créer un site vitrine, choisir WordPress, améliorer son référencement naturel et structurer sa présence en ligne."
        />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content="Blog web, WordPress et SEO | Fold Web Agency" />
        <meta
          property="og:description"
          content="Guides et conseils pour améliorer votre présence en ligne avec un site clair, rapide et mieux référencé."
        />
        <meta property="og:url" content={canonicalUrl} />
        <script type="application/ld+json">
          {JSON.stringify(blogStructuredData)}
        </script>
      </Helmet>

      <Header />

      <main className="blog-page">
        <section className="seo-hero">
          <div className="container">
            <div className="seo-hero-inner">
              <p className="hero-announcement">Blog</p>
              <h1 className="heading-hero">Conseils web, WordPress et SEO</h1>
              <p className="body-large seo-hero-copy">
                Des articles pratiques pour mieux comprendre la création de site,
                le référencement naturel et les choix techniques qui font avancer
                une présence en ligne.
              </p>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container blog-grid">
            {blogPosts.map((post) => (
              <article className="blog-card" key={post.slug}>
                <div className="blog-card-meta">
                  <span>{post.category}</span>
                  <span>{post.readingTime}</span>
                </div>
                <h2 className="heading-3">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h2>
                <p className="body-medium">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`} className="service-learn-more">
                  Lire l'article
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </article>
            ))}
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
